export enum ContactFormNames {
	operationsContactName = 'operationsContactName',
	operationsTelNumber = 'operationsTelNumber',
	mobileNumber = 'mobileNumber',
	operationsEmail = 'operationsEmail',
	adminContactName = 'adminContactName',
	adminTelNumber = 'adminTelNumber',
	adminEmail = 'adminEmail',
}
